import { render, staticRenderFns } from "./OverdueNotice1.vue?vue&type=template&id=23d58be6&"
import script from "./OverdueNotice1.vue?vue&type=script&lang=js&"
export * from "./OverdueNotice1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports